"use strict"

import React from "react"
import { Button, Popover, OverlayTrigger } from "react-bootstrap"

import ZoomControls from "./ZoomControls"
import { withZoomState } from "../../config/ZoomConfigProvider"
import { isLTPM } from "../../../components/shared_components_registration"
const registration = {
  popover_title: (intl) =>
    isLTPM ? intl.formatMessage({ id: "graphing.plotZoomControls.popover.title" }) : "Zoom",
  zoom_controls_btn_label: (intl) =>
    isLTPM ? intl.formatMessage({ id: "graphing.plotZoomControls.button.title" }) : "Zoom Controls",
  zoom_out_label: (intl) =>
    isLTPM ? intl.formatMessage({ id: "graphing.zoomControls.zoom.out.title" }) : "Zoom Out",
  zoom_in_label: (intl) =>
    isLTPM ? intl.formatMessage({ id: "graphing.zoomControls.zoom.in.title" }) : "Zoom In",
}

/*
 * This component is shared and *identical* between LanzaLake and LTPM
 * All changes should be generalized and added to registration as needed
 *  */
export default function ZoomControlsPopover(props) {
  const { placement, intl, graphKey } = props

  const overlay = (
    <Popover id={"zoomconfig"} title={registration.popover_title(intl)}>
      <Popover.Header as={"h3"}>{registration.popover_title(intl)}</Popover.Header>
      <Popover.Body style={{ padding: "8px" }}>
        <ZoomControls {...props} />
      </Popover.Body>
    </Popover>
  )

  return (
    <OverlayTrigger trigger={"click"} placement={placement} rootClose overlay={overlay}>
      <Button
        title={registration.zoom_controls_btn_label(intl)}
        variant={"outline-primary"}
        disabled={
          (graphKey && graphKey.special === "heatmap") ||
          (graphKey && graphKey.observations && graphKey.observations.length === 0)
        }
      >
        <span className={"fa fa-search-plus"} />
      </Button>
    </OverlayTrigger>
  )
}

const _ZoomOutButton = ({ zoomConfig, intl }) => {
  return (
    <Button
      title={registration.zoom_out_label(intl)}
      onClick={(_) => {
        zoomConfig.unzoomTime()
        zoomConfig.unzoomAllPlots()
      }}
      variant={"outline-primary"}
      disabled={!zoomConfig.plotsAreZoomed()}
    >
      <span className={"fa fa-search-minus"} />
    </Button>
  )
}

export const ZoomOutButton = withZoomState(_ZoomOutButton)

const _ZoomInButton = ({ zoomConfig, intl, customOnClick }) => {
  return (
    <Button
      title={registration.zoom_in_label(intl)}
      variant={"outline-primary"}
      onClick={(e) => {
        e.preventDefault()
        zoomConfig.toggleZoomMode()
        customOnClick ? customOnClick() : null
      }}
      className={zoomConfig.isZoomMode() ? "btn-selected" : ""}
    >
      <span className={"fa fa-search-plus"} />
    </Button>
  )
}

export const ZoomInButton = withZoomState(_ZoomInButton)
